import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import EnquiryModal from "./components/EnquiryModal";

import Home from "./pages/Home";
import Properties from "./pages/Properties";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import SobhaRealty from "./pages/SobhaRealty";

// Property Pages
import Residential from "./pages/properties/Residential";
import PropertyDetail from "./pages/properties/PropertyDetail";
import Commercial from "./pages/properties/Commercial";
import Industrial from "./pages/properties/Industrial";
import LandPlot from "./pages/properties/LandPlot";
import SpecialProperty from "./pages/properties/SpecialProperty";
import FarmhouseVillas from "./pages/properties/FarmhouseVillas";
import PlanSale from "./pages/properties/PlanSale";
import AvailableProperties from "./pages/properties/AvailableProperties";

// Service Pages
import RentLease from "./pages/services/RentLease";
import BuySell from "./pages/services/BuySell";
import CommercialService from "./pages/services/Commercial";
import Collaborations from "./pages/services/Collaborations";
import InteriorProjects from "./pages/services/InteriorProjects";

// Create a wrapper component to handle modal logic
function AppContent() {
  const location = useLocation();
  const [isEnquiryModalOpen, setIsEnquiryModalOpen] = useState(false);

  useEffect(() => {
    // Define exact pages where modal should appear
    const exactModalPages = ['/', '/contact'];
    
    // Check if current page matches exact pages OR starts with /properties/residential
    const shouldShowModal = 
      exactModalPages.includes(location.pathname) || 
      location.pathname.startsWith('/properties/residential');
    
    setIsEnquiryModalOpen(shouldShowModal);
  }, [location.pathname]);

  return (
    <>
      <div style={{ 
        width: '100%', 
        maxWidth: '100vw', 
        overflowX: 'hidden',
        position: 'relative'
      }}>
        <Navbar />
        
        <div style={{ 
          width: '100%', 
          maxWidth: '100vw', 
          overflowX: 'hidden' 
        }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/properties" element={<Properties />} />
            <Route path="/properties/available" element={<AvailableProperties />} />
            <Route path="/properties/residential" element={<Residential />} />
            <Route path="/properties/residential/:slug" element={<PropertyDetail />} />
            <Route path="/properties/commercial" element={<Commercial />} />
            <Route path="/properties/commercial/:slug" element={<PropertyDetail />} />
            <Route path="/properties/industrial" element={<Industrial />} />
            <Route path="/properties/industrial/:slug" element={<PropertyDetail />} />
            <Route path="/properties/land-plot" element={<LandPlot />} />
            <Route path="/properties/land-plot/:slug" element={<PropertyDetail />} />
            <Route path="/properties/special" element={<SpecialProperty />} />
            <Route path="/properties/special/:slug" element={<PropertyDetail />} />
            <Route path="/properties/farmhouse-villas" element={<FarmhouseVillas />} />
            <Route path="/properties/farmhouse-villas/:slug" element={<PropertyDetail />} />
            <Route path="/properties/plan-sale" element={<PlanSale />} />
            <Route path="/sobha-realty" element={<SobhaRealty />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/rent-lease" element={<RentLease />} />
            <Route path="/services/buy-sell" element={<BuySell />} />
            <Route path="/services/commercial" element={<CommercialService />} />
            <Route path="/services/collaborations" element={<Collaborations />} />
            <Route path="/services/interior-projects" element={<InteriorProjects />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </div>

        <Footer />
        
        {/* Enquiry Modal - Opens on specific pages */}
        <EnquiryModal 
          isOpen={isEnquiryModalOpen} 
          onClose={() => setIsEnquiryModalOpen(false)} 
        />
      </div>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
